/* ============================================================
 * Scent Quiz Popup — logic, state, transitions, Klaviyo, routing
 * Spec: .claude/skills/scent-quiz-popup/SKILL.md
 * Vanilla JS. No frameworks. No emoji (breaks Claude Desktop preview).
 * ============================================================ */
(function () {
  "use strict";

  /* ---------- Canonical scent records (all 7) ----------
   * One record per scent, keyed by product handle. Both heroes and alts resolve
   * against this map, so when a customer taps an alt to promote it to the main
   * scent the reveal has full data (image, descriptor, ingredient pills).
   *
   * Ingredient pills + accent colors for the 5 hero scents are LOCKED (resolved
   * from Scent Discovery, per TODO.md). Brazilian Passion + African Sandalwood
   * were NOT in the resolved set; their ingredients + heroDescriptor below are
   * PLACEHOLDERS pending Troy's real values (they only ever appeared as alts).
   * --------------------------------------------------------------------------- */
  var SCENTS = {
    "italian-sea-salt": {
      handle: "italian-sea-salt", name: "Italian Sea Salt", accentColor: "#0ea5e9",
      heroDescriptor: "Sun-warmed citrus over salt-dried linen. Clean, bright, unmistakably coastal.",
      shortDescriptor: "Crisp, citrus, classic",
      ingredients: ["SEA SALT", "CEDARWOOD", "CITRUS"],
      image: "scent-quiz-hero-italian-riviera.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/58.png?width=800",
      imageFit: "contain" // bottle product shot; switch to "cover" for a 3:2 lifestyle photo
    },
    "maldivian-palm": {
      handle: "maldivian-palm", name: "Maldivian Palm", accentColor: "#0adb9b",
      heroDescriptor: "Coconut milk and green palm fronds. Fresh, tropical, weightless.",
      shortDescriptor: "Coconut, beachy, bright",
      ingredients: ["COCONUT", "PINEAPPLE", "PALM"],
      image: "scent-quiz-hero-maldivian-palm.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/49_403f2ffc-6c1a-4e86-b8e2-8f6ab9e478de.png?width=800",
      imageFit: "contain"
    },
    "tahitian-vanilla": {
      handle: "tahitian-vanilla", name: "Tahitian Vanilla", accentColor: "#ffaa37",
      heroDescriptor: "Cured vanilla bean wrapped in toasted sugar. Sweet without being sticky.",
      shortDescriptor: "Smooth, sweet, soft",
      ingredients: ["VANILLA", "CASHMERE", "SHEA BUTTER"],
      image: "scent-quiz-hero-tahitian-vanilla.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/42_6117865f-0e66-455c-99bb-3154b37fccc4.png?width=800",
      imageFit: "contain"
    },
    "moroccan-rose": {
      handle: "moroccan-rose", name: "Moroccan Rose", accentColor: "#ec4899",
      heroDescriptor: "Damask rose petals on warm stone. Floral, dry, never powdery.",
      shortDescriptor: "Subtle, elevated floral",
      ingredients: ["DAMASK ROSE", "PINK PEPPER", "PEONY"],
      image: "scent-quiz-hero-moroccan-rose.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/6_25f48ca0-4408-4117-a55d-b337f5460815.png?width=800",
      imageFit: "contain"
    },
    "french-cognac": {
      handle: "french-cognac", name: "French Cognac", accentColor: "#ef4444",
      heroDescriptor: "Aged spirit poured over warm leather. Deep, smoky, quietly luxurious.",
      shortDescriptor: "Heavy cologne, going-out",
      ingredients: ["COGNAC", "LEATHER", "MANDARIN"],
      image: "scent-quiz-hero-french-cognac.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/22_5c794e0a-e8f2-4815-bd1e-5c1b7bdc54a2.png?width=800",
      imageFit: "contain"
    },
    "brazilian-passion": {
      handle: "brazilian-passion", name: "Brazilian Passion", accentColor: "#a855f7",
      heroDescriptor: "Passionfruit over crushed orchid. Juicy, ripe, a little untamed.",
      shortDescriptor: "Sweet candy, playful",
      ingredients: ["PASSIONFRUIT", "PISTACHIO", "DARK CHERRY"], // from bundle-v2 template
      image: "scent-quiz-hero-brazilian-passion.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/14_8fb15828-233c-44e3-89fa-d65d6c0c4c16.png?width=800",
      imageFit: "contain"
    },
    "african-sandalwood": {
      handle: "african-sandalwood", name: "African Sandalwood", accentColor: "#f97316",
      heroDescriptor: "Warm sandalwood and soft vanilla. Earthy, grounded, the whole-day scent.",
      shortDescriptor: "Warm woody, cozy",
      ingredients: ["BERGAMOT", "SANDALWOOD", "VANILLA"], // from bundle-v2 template
      image: "scent-quiz-hero-african-sandalwood.webp",
      imageUrl: "https://cdn.shopify.com/s/files/1/0687/7898/3698/files/31_cbdc33f3-9f33-4f41-bedb-bd781c133eb6.png?width=800",
      imageFit: "contain"
    }
  };

  /* ---------- Vibe buckets (5) ----------
   * Each references scent handles only; copy resolves from SCENTS above.
   * heroHandle = the recommended match; altHandles = the two "also try" options.
   */
  var SCENT_VIBES = {
    fresh_clean:     { id: "fresh_clean",     title: "Fresh & clean",     subtitle: "Light, citrus, crisp",                       accentColor: "#0ea5e9", heroHandle: "italian-sea-salt", altHandles: ["maldivian-palm", "moroccan-rose"] },
    tropical_playful:{ id: "tropical_playful",title: "Tropical & playful",subtitle: "Coconut, sunshine, vacation",                 accentColor: "#0adb9b", heroHandle: "maldivian-palm",  altHandles: ["italian-sea-salt", "brazilian-passion"] },
    cozy_warm:       { id: "cozy_warm",       title: "Cozy & warm",       subtitle: "Smooth, sweet, blanket-soft",                accentColor: "#ffaa37", heroHandle: "tahitian-vanilla",altHandles: ["african-sandalwood", "brazilian-passion"] },
    soft_floral:     { id: "soft_floral",     title: "Soft & floral",     subtitle: "Subtle, elevated, not your grandma's rose",  accentColor: "#ec4899", heroHandle: "moroccan-rose",   altHandles: ["tahitian-vanilla", "italian-sea-salt"] },
    bold_masculine:  { id: "bold_masculine",  title: "Bold & masculine",  subtitle: "Cologne-strong, statement",                  accentColor: "#ef4444", heroHandle: "french-cognac",   altHandles: ["african-sandalwood", "italian-sea-salt"] }
  };

  // Order of vibe options on Screen 1 (locked copy order)
  var VIBE_ORDER = ["fresh_clean", "tropical_playful", "cozy_warm", "soft_floral", "bold_masculine"];

  // Live reveal selection (mutated when an alt is promoted to the main scent)
  var currentReveal = { heroHandle: null, altHandles: [] };

  /* ---------- Config / constants ---------- */
  var STATE_KEY = "loaded_quiz_state";        // "dismissed" | "completed"
  var STATE_TS_KEY = "loaded_quiz_state_ts";  // ISO timestamp
  var SESSION_SHOWN_KEY = "loaded_quiz_shown_session";
  var COOLOFF_DAYS = 7;
  var SHOW_DELAY_MS = 15000; // locked decision (TODO.md): 15s timer
  var SCROLL_TRIGGER_PCT = 0.30;
  var KLAVIYO_REVISION = "2024-10-15";

  /* ---------- DOM refs (populated on init) ---------- */
  var overlay, modal, screens, selectedVibeKey = null;
  // a11y: element focused before the popup opened, so we can restore it on close
  var lastFocused = null;

  /* Test mode: append ?sqptest=1 to any URL. Popup opens instantly, accepts an
   * empty email, skips the Klaviyo call, and does NOT persist completed state,
   * so the full flow can be looped without re-entering an email. */
  var TEST_MODE = /[?&]sqptest=1/.test(window.location.search);

  /* ---------- Helpers ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());
  }

  /* a11y: focusable elements inside the popup. Inactive screens are display:none,
   * so offsetParent filtering naturally scopes this to the active screen. */
  function getFocusable() {
    return $all('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])', overlay)
      .filter(function (el) { return el.offsetParent !== null; });
  }

  function getState() { try { return localStorage.getItem(STATE_KEY); } catch (e) { return null; } }
  function setState(val) {
    try {
      localStorage.setItem(STATE_KEY, val);
      localStorage.setItem(STATE_TS_KEY, new Date().toISOString());
    } catch (e) { /* private mode — ignore */ }
  }

  // Reuse the site's existing Klaviyo subscriber detection (__kla_id cookie)
  function isKlaviyoSubscriber() {
    try {
      var match = document.cookie.match(/__kla_id=([^;]*)/);
      var value = match ? match[1].trim() : null;
      if (!value) return false;
      var data = JSON.parse(atob(value));
      return !!(data && data.$email);
    } catch (e) { return false; }
  }

  function isExcludedPath() {
    var p = window.location.pathname;
    if (p.indexOf("/checkouts") === 0 || p === "/cart" || p.indexOf("/cart/") === 0) return true;
    if (p.indexOf("/pages/bundle-v2") === 0) return true;
    // Scents Collection page — it IS the scent education; popup is redundant there.
    if (p.indexOf("/pages/scents") === 0) return true;
    // Loop Subscriptions customer portal (app proxy at /a/loop_subscriptions/...)
    if (p.indexOf("loop_subscriptions") !== -1) return true;
    return false;
  }

  function withinCooloff() {
    var state = getState();
    if (state === "completed") return true; // never show again
    if (state === "dismissed") {
      var ts = null;
      try { ts = localStorage.getItem(STATE_TS_KEY); } catch (e) {}
      if (!ts) return false;
      var elapsed = Date.now() - new Date(ts).getTime();
      return elapsed < COOLOFF_DAYS * 24 * 60 * 60 * 1000;
    }
    return false;
  }

  function shouldShow() {
    // Don't auto-trigger inside Shopify's theme/checkout customizer iframe —
    // it makes editing painful. TEST_MODE bypasses this so the popup can still
    // be previewed in the customizer with ?sqptest=1 if you actually want to.
    if (window.Shopify && window.Shopify.designMode) return false;
    if (isExcludedPath()) return false;
    if (isKlaviyoSubscriber()) return false;
    if (withinCooloff()) return false;
    try { if (sessionStorage.getItem(SESSION_SHOWN_KEY)) return false; } catch (e) {}
    return true;
  }

  /* ---------- Rendering ---------- */
  function renderVibeOptions() {
    var wrap = $("[data-sqp-vibes]", overlay);
    if (!wrap) return;
    wrap.innerHTML = VIBE_ORDER.map(function (key) {
      var v = SCENT_VIBES[key];
      return (
        '<button type="button" class="sqp-vibe" data-vibe="' + key + '">' +
          '<span class="sqp-vibe__dot" style="background:' + v.accentColor + '"></span>' +
          '<span class="sqp-vibe__text">' +
            '<span class="sqp-vibe__title">' + v.title + '</span>' +
            '<span class="sqp-vibe__sub">' + v.subtitle + '</span>' +
          '</span>' +
        '</button>'
      );
    }).join("");
    $all("[data-vibe]", wrap).forEach(function (btn) {
      btn.addEventListener("click", function () { selectVibe(btn.getAttribute("data-vibe")); });
    });
  }

  function renderChip(screenEl, vibe) {
    var dot = $("[data-sqp-chip-dot]", screenEl);
    var label = $("[data-sqp-chip-label]", screenEl);
    if (dot) dot.style.background = vibe.accentColor;
    if (label) label.textContent = vibe.title.toUpperCase();
  }

  // Screen 3 chip tracks the currently-active scent (updates as the customer
  // taps alts to swap heroes). Dot color and label both reflect that scent.
  function renderActiveScentChip(screenEl) {
    var hero = SCENTS[currentReveal.heroHandle];
    if (!hero) return;
    var dot = $("[data-sqp-chip-dot]", screenEl);
    var label = $("[data-sqp-chip-label]", screenEl);
    if (dot) dot.style.background = hero.accentColor;
    if (label) label.textContent = hero.name.toUpperCase();
  }

  // Render only the hero block (image, name, descriptor, pills) from currentReveal.
  function renderHeroBlock(screen3) {
    var hero = SCENTS[currentReveal.heroHandle];
    if (!hero) return;

    var heroBox = $("[data-sqp-hero]", screen3);
    if (hero.imageUrl) {
      var fit = hero.imageFit || "cover";
      heroBox.innerHTML = '<img src="' + hero.imageUrl + '" alt="' + hero.name + '" style="object-fit:' + fit + '">';
      heroBox.style.background = ""; // fall back to CSS default (transparent, modal cream shows)
    } else {
      heroBox.innerHTML = "";
      heroBox.style.background =
        "linear-gradient(135deg, " + hero.accentColor + "33 0%, #F5F0E8 55%, " + hero.accentColor + "22 100%)";
    }

    $("[data-sqp-hero-name]", screen3).textContent = hero.name;
    $("[data-sqp-hero-desc]", screen3).textContent = hero.heroDescriptor;

    var pills = $("[data-sqp-pills]", screen3);
    pills.innerHTML = (hero.ingredients || []).slice(0, 3).map(function (ing) {
      return '<span class="sqp-pill">' + ing + '</span>';
    }).join("");
  }

  // Render the two "also try" cards from currentReveal.altHandles. Tappable:
  // a tap promotes that alt to the main scent (swap), with the old hero taking
  // the alt's slot. See promoteAlt().
  function renderAlts(screen3) {
    var altsWrap = $("[data-sqp-alts]", screen3);
    altsWrap.innerHTML = currentReveal.altHandles.slice(0, 2).map(function (handle) {
      var alt = SCENTS[handle];
      if (!alt) return "";
      return (
        '<button type="button" class="sqp-alt" data-alt-handle="' + alt.handle + '">' +
          '<span class="sqp-alt__top">' +
            '<span class="sqp-alt__dot" style="background:' + alt.accentColor + '"></span>' +
            '<span class="sqp-alt__name">' + alt.name + '</span>' +
          '</span>' +
          '<span class="sqp-alt__desc">' + alt.shortDescriptor + '</span>' +
          '<span class="sqp-alt__switch">Tap to switch</span>' +
        '</button>'
      );
    }).join("");

    $all("[data-alt-handle]", altsWrap).forEach(function (btn) {
      btn.addEventListener("click", function () { promoteAlt(btn.getAttribute("data-alt-handle")); });
    });
  }

  function renderReveal(vibe) {
    var screen3 = $("[data-sqp-screen='3']", overlay);
    renderActiveScentChip(screen3);
    renderHeroBlock(screen3);
    renderAlts(screen3);
  }

  // Pure state swap: promote `handle` (an alt) to hero, demote the old hero into
  // the slot the alt vacated. Shared by the customer tap (promoteAlt) and the
  // sold-out hero guard (ensureAvailableHero).
  function swapHeroWithAlt(handle) {
    var idx = currentReveal.altHandles.indexOf(handle);
    if (idx === -1) return;
    var oldHero = currentReveal.heroHandle;
    currentReveal.heroHandle = handle;
    currentReveal.altHandles[idx] = oldHero;
  }

  // Promote a tapped alt to the main scent. The previously-selected hero drops
  // into the slot the alt vacated. Animates the hero block during the swap.
  function promoteAlt(handle) {
    if (currentReveal.altHandles.indexOf(handle) === -1) return;
    swapHeroWithAlt(handle);

    var screen3 = $("[data-sqp-screen='3']", overlay);
    var block = $("[data-sqp-hero-block]", screen3);
    if (block) {
      block.classList.add("is-swapping");
      setTimeout(function () {
        renderActiveScentChip(screen3);
        renderHeroBlock(screen3);
        renderAlts(screen3);
        // next frame: remove the class so it animates back in
        requestAnimationFrame(function () { block.classList.remove("is-swapping"); });
      }, 200);
    } else {
      renderActiveScentChip(screen3);
      renderHeroBlock(screen3);
      renderAlts(screen3);
    }
  }

  /* ---------- Sold-out hero guard ----------
   * Scents can sell out (inventory 0, policy DENY) while the quiz still
   * recommends them. Just before the reveal renders, check the hero's live
   * availability via /products/HANDLE.js; if it's unavailable, promote the
   * first available alt into the hero slot (reusing swapHeroWithAlt, the same
   * state swap a customer tap performs). Fail-open on any error/bad shape, and
   * cap the whole check so the reveal is never delayed more than AVAIL_TIMEOUT_MS.
   */
  var AVAIL_TIMEOUT_MS = 1500;
  var availabilityCache = {}; // handle -> boolean, session-scoped

  function fetchAvailability(handle) {
    if (Object.prototype.hasOwnProperty.call(availabilityCache, handle)) {
      return Promise.resolve(availabilityCache[handle]);
    }
    return fetch("/products/" + handle + ".js")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var available = !(data && data.available === false); // unexpected shape -> fail open
        availabilityCache[handle] = available;
        return available;
      })
      .catch(function () { return true; }); // network/parse error -> fail open, don't cache
  }

  // Walk alts in order, promoting the first available one to hero. isStale() lets
  // the timeout abort a late swap so it can't change the hero after the reveal shows.
  function promoteFirstAvailableAlt(alts, i, isStale) {
    if (isStale() || i >= alts.length) return Promise.resolve();
    var handle = alts[i];
    return fetchAvailability(handle).then(function (available) {
      if (isStale()) return;
      if (available) { swapHeroWithAlt(handle); return; }
      return promoteFirstAvailableAlt(alts, i + 1, isStale);
    });
  }

  // Resolve currentReveal.heroHandle to an available scent where possible. Always
  // resolves (never rejects); races the check against AVAIL_TIMEOUT_MS.
  function ensureAvailableHero() {
    var done = false;
    function isStale() { return done; }
    return new Promise(function (resolve) {
      var timer = setTimeout(function () { done = true; resolve(); }, AVAIL_TIMEOUT_MS);
      function finish() { done = true; clearTimeout(timer); resolve(); }
      fetchAvailability(currentReveal.heroHandle).then(function (available) {
        if (done || available) return null;
        return promoteFirstAvailableAlt(currentReveal.altHandles.slice(), 0, isStale);
      }).then(finish, finish);
    });
  }

  /* ---------- Screen transitions ---------- */
  function goToScreen(n) {
    screens.forEach(function (s) {
      s.classList.toggle("is-active", s.getAttribute("data-sqp-screen") === String(n));
    });
    if (modal) modal.scrollTop = 0;
  }

  function selectVibe(key) {
    selectedVibeKey = key;
    var vibe = SCENT_VIBES[key];
    if (!vibe) return;
    // Seed the live reveal selection from the vibe's recommended match.
    currentReveal.heroHandle = vibe.heroHandle;
    currentReveal.altHandles = vibe.altHandles.slice();
    renderChip($("[data-sqp-screen='2']", overlay), vibe);
    goToScreen(2);
    var emailInput = $("[data-sqp-email]", overlay);
    if (emailInput) setTimeout(function () { emailInput.focus(); }, 250);
  }

  /* ---------- Scroll lock ----------
   * Locks background scroll while the popup is open. Uses the position:fixed
   * technique so it also holds on iOS Safari (plain overflow:hidden leaks there).
   */
  var savedScrollY = 0;
  function lockScroll() {
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    var b = document.body;
    b.style.position = "fixed";
    b.style.top = "-" + savedScrollY + "px";
    b.style.left = "0";
    b.style.right = "0";
    b.style.width = "100%";
    b.style.overflow = "hidden";
  }
  function unlockScroll() {
    var b = document.body;
    b.style.position = "";
    b.style.top = "";
    b.style.left = "";
    b.style.right = "";
    b.style.width = "";
    b.style.overflow = "";
    window.scrollTo(0, savedScrollY);
  }

  /* ---------- Open / close ---------- */
  function openPopup() {
    // a11y: remember what had focus so we can restore it when the popup closes
    lastFocused = document.activeElement;
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    lockScroll();
    // force reflow so the opacity/transform transition runs
    void overlay.offsetWidth;
    overlay.classList.add("is-visible");
    // a11y: move focus into the dialog so screen readers announce it and Tab is trapped
    if (modal) { try { modal.focus(); } catch (e) {} }
    try { sessionStorage.setItem(SESSION_SHOWN_KEY, "1"); } catch (e) {}
  }

  function closePopup(markDismissed) {
    overlay.classList.remove("is-visible");
    if (markDismissed && getState() !== "completed") setState("dismissed");
    unlockScroll();
    // a11y: return focus to wherever it was before the popup opened
    if (lastFocused && typeof lastFocused.focus === "function") {
      try { lastFocused.focus(); } catch (e) {}
    }
    lastFocused = null;
    setTimeout(function () {
      overlay.classList.remove("is-open");
      overlay.setAttribute("aria-hidden", "true");
    }, 300);
  }

  /* ---------- Klaviyo ---------- */
  function subscribeToKlaviyo(email, vibe) {
    var companyId = overlay.getAttribute("data-company-id");
    var listId = overlay.getAttribute("data-list-id");
    var url = "https://a.klaviyo.com/client/subscriptions/?company_id=" + encodeURIComponent(companyId);

    var heroScent = SCENTS[vibe.heroHandle] || {};
    var payload = {
      data: {
        type: "subscription",
        attributes: {
          custom_source: "Scent Quiz Popup",
          profile: {
            data: {
              type: "profile",
              attributes: {
                email: email,
                properties: {
                  scent_vibe: vibe.id,
                  scent_vibe_title: vibe.title,
                  hero_scent: vibe.heroHandle,
                  hero_scent_name: heroScent.name || "",
                  alt_scent_1: vibe.altHandles[0] || "",
                  alt_scent_2: vibe.altHandles[1] || "",
                  quiz_completed_at: new Date().toISOString(),
                  quiz_source: "popup_v1"
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: "list", id: listId } } }
      }
    };

    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", "revision": KLAVIYO_REVISION },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error("Klaviyo subscribe failed: " + res.status);
      return true;
    });
  }

  /* ---------- CTA routing ----------
   * WASH15 auto-apply is DISABLED 2026-06-01: tried both /discount/CODE?redirect=
   * and inline ?discount=CODE + a preflight fetch — none reliably applied the code
   * at checkout. Until root-caused, the popup CTA only carries ?scents= so the
   * scent pre-selects. WASH15 trust line removed from the reveal. Klaviyo welcome
   * flow still has the code, customers can apply it manually at checkout.
   * To re-enable: restore the &discount= param + preflight fetch + the trust line.
   */
  function buildCtaUrl() {
    var bundleUrl = overlay.getAttribute("data-bundle-url") || "/pages/build-your-bundle";
    return bundleUrl + "?scents=" + encodeURIComponent(currentReveal.heroHandle);
  }

  function navigateToBundle() {
    window.location.href = buildCtaUrl();
  }

  /* ---------- Form submit ---------- */
  function handleSubmit(e) {
    e.preventDefault();
    var emailInput = $("[data-sqp-email]", overlay);
    var errorEl = $("[data-sqp-error]", overlay);
    var submitBtn = $("[data-sqp-submit]", overlay);
    var email = (emailInput.value || "").trim();
    var vibe = SCENT_VIBES[selectedVibeKey];

    function reveal() {
      if (!TEST_MODE) setState("completed");
      // Swap out a sold-out hero before showing the reveal (fail-open, capped).
      ensureAvailableHero().then(function () {
        renderReveal(vibe);
        goToScreen(3);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = "Reveal my scent &rarr;"; }
      });
    }

    // Test mode: skip validation + Klaviyo, go straight to the reveal.
    if (TEST_MODE) {
      if (errorEl) errorEl.hidden = true;
      reveal();
      return;
    }

    if (!isValidEmail(email)) {
      if (errorEl) errorEl.hidden = false;
      emailInput.focus();
      return;
    }
    if (errorEl) errorEl.hidden = true;

    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Revealing..."; }

    subscribeToKlaviyo(email, vibe)
      .then(reveal)
      .catch(function (err) {
        // Don't block the customer on a network error; still show their match.
        console.warn("[scent-quiz] Klaviyo subscribe failed, revealing anyway:", err);
        reveal();
      });
  }

  /* ---------- Triggers ----------
   * Locked decision (TODO.md): hybrid — exit-intent OR 15s timer OR 30% scroll,
   * whichever fires first. One trigger per session.
   */
  function armTriggers() {
    var fired = false;
    function fire() {
      if (fired) return;
      if (!shouldShow()) return; // re-check at fire time (state may have changed)
      fired = true;
      cleanup();
      openPopup();
    }
    var timer = setTimeout(fire, SHOW_DELAY_MS);
    function onScroll() {
      var scrolled = window.scrollY || window.pageYOffset;
      var docH = document.documentElement.scrollHeight - window.innerHeight;
      if (docH > 0 && scrolled / docH >= SCROLL_TRIGGER_PCT) fire();
    }
    // Exit-intent: cursor leaves the top of the viewport (desktop only — no
    // mouseleave on touch devices, where the 15s/scroll triggers cover it).
    function onMouseOut(e) {
      if (e.clientY <= 0 && !e.relatedTarget) fire();
    }
    function cleanup() {
      clearTimeout(timer);
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("mouseout", onMouseOut);
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("mouseout", onMouseOut);
  }

  /* ---------- Init ---------- */
  function init() {
    overlay = document.getElementById("scent-quiz-popup");
    if (!overlay) return;
    modal = $(".sqp-modal", overlay);
    screens = $all("[data-sqp-screen]", overlay);

    renderVibeOptions();

    // Close handlers (× buttons + skip link all carry data-sqp-close)
    $all("[data-sqp-close]", overlay).forEach(function (el) {
      el.addEventListener("click", function () { closePopup(true); });
    });
    // Click-outside dismissal
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closePopup(true);
    });
    // Esc to close + Tab focus trap (keeps keyboard focus inside the dialog)
    document.addEventListener("keydown", function (e) {
      if (!overlay.classList.contains("is-open")) return;
      if (e.key === "Escape") { closePopup(true); return; }
      if (e.key === "Tab") {
        var f = getFocusable();
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        // if focus has drifted outside the dialog, pull it back in
        if (!overlay.contains(document.activeElement)) {
          e.preventDefault();
          (e.shiftKey ? last : first).focus();
        } else if (e.shiftKey && document.activeElement === first) {
          e.preventDefault(); last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault(); first.focus();
        }
      }
    });

    var form = $("[data-sqp-form]", overlay);
    if (form) form.addEventListener("submit", handleSubmit);

    var cta = $("[data-sqp-cta]", overlay);
    if (cta) cta.addEventListener("click", function () {
      if (currentReveal.heroHandle) navigateToBundle();
    });

    if (TEST_MODE) {
      console.log("[scent-quiz] TEST MODE on: popup opens immediately, email optional, no Klaviyo, state not saved.");
      openPopup();
    } else if (shouldShow()) {
      armTriggers();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
